<template>
  <div
    class="tor-btn"
    :class="`tor-btn--${mobile ? 'mobile' : 'desktop'}`"
    v-if="enabled"
  >
    <div
      @click="$emit('input')"
      @keypress.enter="$emit('input')"
      role="button"
      tabindex="0"
    >
      <v-icon size="14">$close</v-icon> Reset
    </div>
  </div>
</template>

<script>
export default {
  props: {
    enabled: Boolean,
    mobile: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.tor-btn {
  margin-left: 1em;
  margin-bottom: 1em;
  cursor: pointer;
  height: 50px;
  display: flex;
  align-items: center;
  > div {
    font-size: 80%;
    font-weight: bold;
  }
  &--mobile {
    display: none;
  }
}

@media screen and (max-width: 960px) {
  .tor-btn {
    margin-left: 0;
    height: auto;
    &--desktop {
      display: none;
    }
    &--mobile {
      display: block;
    }
  }
}
</style>
